import { MakeLogicType, actions, connect, events, kea, path, reducers, selectors } from 'kea'
import { urlToAction } from 'kea-router'

import { featureFlagLogic } from 'lib/logic/featureFlagLogic'
import { organizationLogic } from 'scenes/organizationLogic'
import { preflightLogic } from 'scenes/PreflightCheck/preflightLogic'
import { teamLogic } from 'scenes/teamLogic'
import { userLogic } from 'scenes/userLogic'

import type { PreflightStatus } from '../types'

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface appLogicValues {
    featureFlagsTimedOut: boolean
    showApp: boolean | PreflightStatus | null
    showingDelayedSpinner: boolean
    showingDevTools: boolean
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface appLogicActions {
    enableDelayedSpinner: () => {
        value: true
    }
    ignoreFeatureFlags: () => {
        value: true
    }
    showDevTools: () => {
        value: true
    }
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface appLogicMeta {
    __keaTypeGenInternalSelectorTypes: {
        showApp: (
            userLoading: boolean,
            user: null | import('../types').UserType,
            receivedFeatureFlags: boolean,
            featureFlagsTimedOut: boolean,
            preflightLoading: boolean,
            preflight: PreflightStatus | null
        ) => boolean | PreflightStatus | null
    }
}

export type appLogicType = MakeLogicType<appLogicValues, appLogicActions, Record<string, any>, appLogicMeta>

export const appLogic = kea<appLogicType>([
    path(['scenes', 'App']),

    connect([teamLogic, organizationLogic, preflightLogic]),
    actions({
        enableDelayedSpinner: true,
        ignoreFeatureFlags: true,
        showDevTools: true,
    }),
    reducers({
        showingDelayedSpinner: [false, { enableDelayedSpinner: () => true }],
        featureFlagsTimedOut: [false, { ignoreFeatureFlags: () => true }],
        showingDevTools: [false, { showDevTools: () => true }],
    }),
    selectors({
        showApp: [
            (s) => [
                userLogic.selectors.userLoading,
                userLogic.selectors.user,
                featureFlagLogic.selectors.receivedFeatureFlags,
                s.featureFlagsTimedOut,
                preflightLogic.selectors.preflightLoading,
                preflightLogic.selectors.preflight,
            ],
            (
                userLoading: boolean,
                user: null | import('../types').UserType,
                receivedFeatureFlags: boolean,
                featureFlagsTimedOut: boolean,
                preflightLoading: boolean,
                preflight: null | import('../types').PreflightStatus
            ) => {
                return (
                    (!userLoading || user) &&
                    (receivedFeatureFlags || featureFlagsTimedOut) &&
                    (!preflightLoading || preflight)
                )
            },
        ],
    }),
    events(({ actions, cache }) => ({
        afterMount: () => {
            cache.disposables.add(() => {
                const timerId = window.setTimeout(() => actions.enableDelayedSpinner(), 1000)
                return () => clearTimeout(timerId)
            }, 'spinnerTimeout')
            cache.disposables.add(() => {
                const timerId = window.setTimeout(() => actions.ignoreFeatureFlags(), 3000)
                return () => clearTimeout(timerId)
            }, 'featureFlagTimeout')
        },
    })),
    urlToAction(({ actions }) => ({
        '*': (_, __, hash) => {
            if ('kea' in hash) {
                actions.showDevTools()
            }
        },
    })),
])
